import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import "./Edit.css";

const EditSiteTeamMember = ({ contact, onClose, onUpdated }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_no: "",
    designation: "",
    is_email_enabled: false,
    is_sms_enabled: false,
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const API_URL = process.env.REACT_APP_API_DJANGO_URL;
  const token = localStorage.getItem("accessToken");

  // ✅ Validation regex
  const nameRegex = /^[A-Za-z]+( [A-Za-z]+)*$/;
// Email: standard format, 2–50 characters
// const emailRegex = /^[^\s@]{2,50}@[^\s@]+\.[^\s@]+$/;
const emailRegex = /^(?=.{2,50}$)[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;

const phoneRegex = /^[6-9]\d{9}$/;     // Starts with 6-9, exactly 10 digits
// Allow letters + spaces, 2–20 chars
const designationRegex = /^[A-Za-z]{2,20}( [A-Za-z]{1,20})*$/;

  useEffect(() => {
    if (contact) {
      setFormData({
        name: contact.name || "",
        email: contact.email || "",
        phone_no: contact.phone_no || "",
        designation: contact.designation || "",
        is_email_enabled: Boolean(Number(contact.is_email_enabled)),
        is_sms_enabled: Boolean(Number(contact.is_sms_enabled)),
      });
    }
  }, [contact]);

  const validateForm = () => {
    const tempErrors = {};

    
  // Name validation
 if (!formData.name.trim()) {
  tempErrors.name = "Name required";
} else if (!nameRegex.test(formData.name.trim())) {
  tempErrors.name = "Only letters and single spaces allowed (2- 40 chars)";
}

   if (!formData.designation.trim()) {
  tempErrors.designation = "Designation required";
} else if (!designationRegex.test(formData.designation)) {
  tempErrors.designation = "Only alphabets allowed, 2–20 chars, spaces allowed";
}

     if (!formData.email.trim()) tempErrors.email = "Email required";
  else if (!emailRegex.test(formData.email)) tempErrors.email = "Invalid email, 2–50 chars";

    if (!formData.phone_no.trim())
      tempErrors.phone_no = "Phone required";
    else if (!phoneRegex.test(formData.phone_no))
      tempErrors.phone_no = "Must start 6–9, 10 digits";

    if (!formData.is_email_enabled && !formData.is_sms_enabled)
      tempErrors.notification = "Select at least one notification";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

 const handleChange = (e) => {
  const { name, value } = e.target;
  let newValue = value;

 if (name === "name") {
  // Allow only letters and spaces
  newValue = newValue.replace(/[^A-Za-z\s]/g, "");

  // Remove leading spaces
  newValue = newValue.replace(/^\s+/, "");

  // Convert multiple spaces into single space
  newValue = newValue.replace(/\s{2,}/g, " ");

  // Limit to 40 characters
  if (newValue.length > 40) newValue = newValue.slice(0, 40);
}

 if (name === "designation") {
  // Remove invalid chars (only letters + spaces)
  newValue = newValue.replace(/[^A-Za-z\s]/g, "");

  // Remove leading spaces
  newValue = newValue.replace(/^\s+/, "");

  // Prevent multiple spaces
  newValue = newValue.replace(/\s{2,}/g, " ");

  // Limit total length to 20 characters
  if (newValue.length > 20) newValue = newValue.slice(0, 20);
}
  // ✅ Disallow all spaces in email
  if (name === "email") {
  // Remove leading/trailing spaces
  newValue = newValue.replace(/^\s+|\s+$/g, "");

  // Limit total length to 50
  if (newValue.length > 50) newValue = newValue.slice(0, 50);
}
  if (name === "phone_no") newValue = newValue.replace(/\D/g, "").slice(0, 10);

  setFormData((prev) => ({ ...prev, [name]: newValue }));

  // Real-time validation
  let error = "";
  if (name === "name") {
  if (!newValue) error = "Name is required";
  else if (!nameRegex.test(newValue))
    error = "Only letters and single spaces allowed (2-40 chars)";
}

 if (name === "designation") {
  if (!newValue) error = "Designation required";
  else if (!designationRegex.test(newValue))
    error = "Only alphabets allowed, 2–20 chars, spaces allowed";
}
  if (name === "email") {
    if (!newValue) error = "Email required";
    else if (!emailRegex.test(newValue)) error = "Invalid email, 2–50 chars";
  }
  if (name === "phone_no") {
    if (!newValue) error = "Phone required";
    else if (!phoneRegex.test(newValue)) error = "Must start 6–9, 10 digits";
  }

  setErrors((prev) => ({ ...prev, [name]: error }));
};

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));

    // Real-time notification validation
    if (!checked && !formData.is_email_enabled && !formData.is_sms_enabled) {
      setErrors((prev) => ({ ...prev, notification: "Select at least one notification" }));
    } else {
      setErrors((prev) => ({ ...prev, notification: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      const payload = {
        ...formData,
        is_email_enabled: formData.is_email_enabled ? 1 : 0,
        is_sms_enabled: formData.is_sms_enabled ? 1 : 0,
      };

      await axios.post(
        `${API_URL}/api/update_site_alert_contact/${contact.id}/`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
        }
      );

      toast.success("Contact updated successfully!");
      if (onUpdated) onUpdated();
      onClose();
    } catch (err) {
      toast.error("Failed to update contact");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="edit-site-modal">
      <Box className="edit-site-container">
        <Typography className="edit-site-title" variant="h5" sx={{ mb: 2 }}>
          Edit Site Team Member
        </Typography>
        <form className="edit-site-form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                error={!!errors.name}
                helperText={errors.name}
                required
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                error={!!errors.email}
                helperText={errors.email}
                required
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Phone Number"
                name="phone_no"
                value={formData.phone_no}
                onChange={handleChange}
                error={!!errors.phone_no}
                helperText={errors.phone_no}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Designation"
                name="designation"
                value={formData.designation}
                onChange={handleChange}
                error={!!errors.designation}
                helperText={errors.designation}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.is_email_enabled}
                      onChange={handleCheckboxChange}
                      name="is_email_enabled"
                    />
                  }
                  label="Email Notifications"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.is_sms_enabled}
                      onChange={handleCheckboxChange}
                      name="is_sms_enabled"
                    />
                  }
                  label="SMS Notifications"
                />
              </FormGroup>
              {errors.notification && (
                <Typography color="error" variant="caption" sx={{ display: "block", mt: 1 }}>
                  {errors.notification}
                </Typography>
              )}
            </Grid>
          </Grid>
          <div className="edit-btn-wrapper" style={{ marginTop: 16 }}>
            <button type="button" className="cancel-btn" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="edit-btn" disabled={loading}>
              {loading ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
        {/* <ToastContainer position="top-right" autoClose={3000} /> */}
      </Box>
    </div>
  );
};

export default EditSiteTeamMember;